




















































































































import { Component, Prop, Vue } from "vue-property-decorator";
import { Dictionary } from "vue-router/types/router";

interface contactFormI {
  name: string;
  email: string;
  phone: string;
  terms: boolean;
}

@Component
export default class Contact extends Vue {
  private contactForm: contactFormI = {
    name: "",
    email: "",
    phone: "",
    terms: true
  };

  validateBeforeSubmit() {
    this.$validator.validateAll().then(result => {
      if (result) {
        this.$buefy.toast.open({
          message: "Form submitted!",
          type: "is-success"
        });

        this.$store.dispatch("setContactForm", this.contactForm);
        this.$router.push({ name: "upload" });

        return;
      }

      this.$buefy.toast.open({
        duration: 5000,
        message: `Please fill out the form!`,
        type: "is-danger"
      });
    });
  }
  confirmCustom() {
    this.$buefy.dialog.confirm({
      title: "terms of use",
      message: `To use the kraken software you have to agree to our terms and conditions. This involves our <a href="./legal/terms_of_use.pdf" download>terms of use</a> and <a href="./legal/data_protection.pdf" download>data protection agreement</a> in particular, which you can download in PDF format by clicking on the links.`,
      cancelText: "Disagree",
      confirmText: "Agree",
      type: "is-success",
      onConfirm: () => {
        this.$buefy.toast.open("User agreed");
        this.contactForm.terms = true;
      },
      onCancel: () => {
        this.contactForm.terms = false;
      }
    });
  }
}
